import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { ListResponse, TeacherState } from '../types'

interface QueryParams {
    query: string
    roles: Array<string>
}

export const teacherApiSlice = createApi({
    reducerPath: 'teacherApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Teacher'],
    endpoints: (build) => ({
        fetchAllTeachers: build.query<ListResponse<TeacherState>, QueryParams>({
            query: (params) => ({
                url: `teacher?${params.query}`,
                params: {
                    roles: params.roles,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Teacher' as const,
                            id,
                        })),
                        { type: 'Teacher', id: 'LIST' },
                    ]
                    : [{ type: 'Teacher', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<TeacherState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        createTeacher: build.mutation<void, FormData>({
            query: (teacher) => ({
                url: 'teacher',
                method: 'POST',
                body: teacher,
            }),
            invalidatesTags: [{ type: 'Teacher', id: 'LIST' }],
        }),

        updateTeacher: build.mutation<void, FormData>({
            query: (teacher) => ({
                url: `teacher/${teacher.get('id')}`,
                method: 'PUT',
                body: teacher,
            }),
            invalidatesTags: [{ type: 'Teacher', id: 'LIST' }],
        }),

        setTeacherBlocked: build.mutation<void, { id: number; blocked: boolean }>({
            query: ({ id, blocked }) => ({
                url: `teacher/${id}/block`,
                method: 'POST',
                body: { blocked },
            }),
            invalidatesTags: [{ type: 'Teacher', id: 'LIST' }],
        }),

        deleteTeacher: build.mutation<void, number>({
            query: (id) => ({
                url: `/teacher/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'Teacher', id }],
        }),
    }),
})
